/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractApproveRequest = {
  properties: {
    contractId: {
      type: 'string',
      isRequired: true,
    },
    contractReviewerId: {
      type: 'string',
      isRequired: true,
    },
    comment: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
